import { z } from 'zod'

const ZBaseAction = z.object({
  id: z.string(),
})

export default ZBaseAction
